import { render, staticRenderFns } from "./ProfileCustomer.vue?vue&type=template&id=040e5504"
import script from "./ProfileCustomer.vue?vue&type=script&lang=js"
export * from "./ProfileCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports